<template>
    <div class="col-12 dict-stat-table">
<!--        <div class="row">-->
<!--            <div class="form-group col-11 col-md-12">-->
<!--                <button type="button" class="col-12 col-md-auto btn btn-default"-->
<!--                        @click="add">{{ $lang('Nowy status') }}-->
<!--                </button>-->
<!--            </div>-->
<!--        </div>-->
        <div class="row" v-if="statuses.length > 0">
            <table class="table simple-table table-striped table-sm">
                <thead>
                <tr>
                    <th scope="col">{{ $lang('Status') }}</th>
                    <th scope="col">{{ $lang('Finalny') }}</th>
                    <th v-if="app_mode === 'ORACLE'" scope="col">{{ $lang('Zegar SLA') }}<sup>1</sup></th>
                    <th v-if="app_mode === 'ORACLE'" scope="col">{{ $lang('Reakcja') }}<sup>2</sup></th>
                    <th v-if="app_mode === 'ORACLE'" scope="col">{{ $lang('Obejście') }}<sup>3</sup></th>
                    <th v-if="app_mode === 'ORACLE'" scope="col">{{ $lang('Rozwiązanie') }}<sup>4</sup></th>
                    <th v-if="app_mode === 'ORACLE'" scope="col">{{ $lang('Autozamknięcie') }}<sup>5</sup></th>
                    <th scope="col">{{ $lang('Akcje') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="status in statuses">
                    <td :data-title="$lang('Status')"><span class="badge badge-dynamic" :style="{ 'background-color': status.color && app_mode === 'ORACLE' ? status.color : '#000' }">{{ status.name }}</span></td>
                    <td :data-title="$lang('Finalny')">
                        <span class="badge"
                              :class="{'badge-success': status.final, 'badge-danger': !status.final}">{{
                                status.final ? 'TAK' : 'NIE'
                            }}</span>
                    </td>
                    <td v-if="app_mode === 'ORACLE'" :data-title="$lang('Zegar SLA')">
                        <span class="badge"
                              :class="{'badge-success': status.sla_clock, 'badge-danger': !status.sla_clock}">{{
                                status.sla_clock ? 'TAK' : 'NIE'
                            }}</span>
                    </td>
                    <td v-if="app_mode === 'ORACLE'" :data-title="$lang('Reakcja')">
                        <span class="badge"
                              :class="{'badge-success': status.consultant_reaction, 'badge-danger': !status.consultant_reaction}">{{
                                status.consultant_reaction ? 'TAK' : 'NIE'
                            }}</span>
                    </td>
                    <td v-if="app_mode === 'ORACLE'" :data-title="$lang('Obejście')">
                        <span class="badge"
                              :class="{'badge-success': status.workaround, 'badge-danger': !status.workaround}">{{
                                status.workaround ? 'TAK' : 'NIE'
                            }}</span>
                    </td>
                    <td v-if="app_mode === 'ORACLE'" :data-title="$lang('Rozwiązanie')">
                        <span class="badge"
                              :class="{'badge-success': status.resolution, 'badge-danger': !status.resolution}">{{
                                status.resolution ? 'TAK' : 'NIE'
                            }}</span>
                    </td>
                    <td v-if="app_mode === 'ORACLE'" :data-title="$lang('Autozamknięcie')">
                        <span class="badge"
                              :class="{'badge-success': status.auto_close, 'badge-danger': !status.auto_close}">{{
                                status.auto_close ? 'TAK' : 'NIE'
                            }}</span>
                    </td>
                    <td :data-title="$lang('Akcje')">
                        <a class="mr-3" @click.prevent="edit(status)" href="#">{{ $lang('Edytuj') }}</a>
                        <a class="mr-3 hidden" @click.prevent="remove(status.id)" href="#">{{ $lang('Usuń') }}</a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="row" v-if="statuses.length > 0 && app_mode === 'ORACLE'">
            <div class="col-12 small">
                <p class="mb-1"><sup>1)</sup> konfiguracja zatrzymania liczenia SLA dla tasku dla określonych statusów</p>
                <p class="mb-1"><sup>2)</sup> pierwsze przejście na status o typ typie powoduję ustalenie czasu faktycznej reakcji</p>
                <p class="mb-1"><sup>3)</sup> statusy o tym typie oznaczają wprowadzenie rozwiązania tymczasowego i powodują wstrzymanie wysłania powiadomienia mailowego przypominającego o konieczności przygotowania obejścia </p>
                <p class="mb-1"><sup>4)</sup> statusy o tym typie oznaczają wprowadzenie rozwiązania i skutkują prośbą do klienta o potwierdzenie poprawności rozwiązania</p>
                <p class="mb-1"><sup>5)</sup> statusy o tym typie oznaczają oczekiwanie na odpowiedź klienta. Brak odpowiedzi powoduje zamknięcie tasku</p>
            </div>
        </div>

        <div class="modal fade" id="modal_dict_status" tabindex="-1">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{
                                modalMode === 'new' ? $lang('Nowy status') : $lang('Edycja statusu')
                            }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <table class="table simple-table table-sm">
                            <thead>
                            <tr>
                                <th scope="col">{{ $lang('Właściwość') }}</th>
                                <th scope="col">{{ $lang('Wartość') }}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>{{$lang('Nazwa')}}</td>
                                <td>
                                    <input class="form-control" id="new_status" placeholder="Nazwa"
                                           v-model="statusEditable.name">
                                    <small class="text-red" v-if="error === true">
                                        {{ errorMessage }}</small>
                                </td>
                            </tr>
                            <tr>
                                <td>{{ $lang('Status końcowy') }}</td>
                                <td>
                                    <div class="form-group" style="margin-bottom: 0;">
                                        <input type="checkbox" id="new_status_final" v-model="statusEditable.final">
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="app_mode === 'ORACLE'">
                                <td>{{ $lang('Zegar SLA') }}</td>
                                <td>
                                    <div class="form-group" style="margin-bottom: 0;">
                                        <input type="checkbox" id="sla_clock" v-model="statusEditable.sla_clock">
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="app_mode === 'ORACLE'">
                                <td>{{ $lang('Reakcja') }}</td>
                                <td>
                                    <div class="form-group" style="margin-bottom: 0;">
                                        <input type="checkbox" id="consultant_reaction"
                                               v-model="statusEditable.consultant_reaction">
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="app_mode === 'ORACLE'">
                                <td>{{ $lang('Obejście') }}</td>
                                <td>
                                    <div class="form-group" style="margin-bottom: 0;">
                                        <input type="checkbox" id="workaround" v-model="statusEditable.workaround">
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="app_mode === 'ORACLE'">
                                <td>{{ $lang('Rozwiązanie') }}</td>
                                <td>
                                    <div class="form-group" style="margin-bottom: 0;">
                                        <input type="checkbox" id="workaround" v-model="statusEditable.resolution">
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="app_mode === 'ORACLE'">
                                <td>{{ $lang('Autozamknięcie') }}</td>
                                <td>
                                    <div class="form-group" style="margin-bottom: 0;">
                                        <input type="checkbox" id="auto_close" v-model="statusEditable.auto_close">
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="app_mode === 'ORACLE'">
                                <td>{{ $lang('Prezentacja') }}</td>
                                <td>
                                    <LvColorPicker
                                        :key="'cpicker-' + statusEditable.id"
                                        label="Kolor"
                                        v-model="statusEditable.color"
                                        :hidePalette="true"
                                        :withoutInput="true"
                                        :colors="[]"
                                    />
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">{{
                                $lang('Zamknij')
                            }}
                        </button>
                        <button id="status-new" v-if="modalMode === 'new'" @click.prevent="create()" type="button"
                                class="btn btn-primary" :disabled="!newStatusValid">
                            {{ $lang('Utwórz') }}
                        </button>
                        <button id="status-edit" v-else @click.prevent="update()" type="button" class="btn btn-primary"
                                :disabled="!newStatusValid">
                            {{ $lang('Zapisz') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ShowNotification from "../../mixins/show-notification";
export default {
    name: "dictionary-status",
    mixins: [ShowNotification],
    props: ['update_route', 'get_route', 'store_route', 'delete_route', 'app_mode'],
    data() {
        return {
            statuses: [],
            error: false,
            errorMessage: '',
            statusEditable: {
                id: null,
                name: '',
                final: false,
                sla_clock: false,
                color: '#000',
                consultant_reaction: true,
                workaround: false,
                auto_close: false,

            },
            modalMode: 'add'
        }
    },
    methods: {
        deleteElement(type) {

        },
        get() {
            let self = this;
            axios.get(this.get_route, {})
                 .then(function (response) {
                     self.statuses = response.data;
                 })
                 .catch((error) => {
                 });
        },
        create() {
            let self = this;
            axios.post(this.store_route, this.statusEditable)
                 .then(function (response) {
                     self.statuses = response.data;
                     $('#modal_dict_status').modal('hide');
                 })
                 .catch((error) => {
                     if (error.response.status === 422) {
                         self.error = true;
                         self.errorMessage = error.response.data;
                     }
                 });
        },
        update() {
            let self = this;
            axios.patch(this.update_route, this.statusEditable)
                 .then(function (response) {
                     self.statuses = response.data;
                     $('#modal_dict_status').modal('hide');
                 })
                 .catch((error) => {
                     console.log(error);
                     if (error.response.status === 422) {
                         self.error = true;
                         self.errorMessage = error.response.data;
                     }
                 });
        },
        remove(id) {
            let self = this;
            axios.post(this.delete_route, {id: id})
                 .then(function (response) {
                     self.statuses = response.data;
                     self.showNotification('success', self.$lang('Status został usunięty!'));
                 })
                 .catch((error) => {
                     if (error.response.status === 422) {
                         this.showNotification('error', error.response.data.errors)
                     } else if (error.response.status === 400) {
                         this.showNotification('error', error.response.data.msg);
                     } else {
                         console.log(error);
                     }
                 });
        },
        add() {
            this.openModal('new', null);
        },
        edit(status) {
            this.openModal('edit', status);
        },
        openModal(mode, status) {
            this.modalMode = mode;
            this.error = false;
            this.errorMessage = '';
            this.statusEditable.id = status ? status.id : null;
            this.statusEditable.name = status ? status.name : null;
            this.statusEditable.final = status ? status.final : false;
            this.statusEditable.sla_clock = status ? status.sla_clock : false;
            this.statusEditable.consultant_reaction = status ? status.consultant_reaction : false;
            this.statusEditable.workaround = status ? status.workaround : false;
            this.statusEditable.resolution = status ? status.resolution : false;
            this.statusEditable.auto_close = status ? status.auto_close : false;
            this.statusEditable.color = status && status.color ? status.color : '#000';
            $('#modal_dict_status').modal('show');
        }

    },
    computed: {
        newStatusValid() {
            return this.statusEditable.name !== '';
        }
    },
    created() {
        this.get();

    },
    mounted() {

    }
}
</script>
<style>
div#image_overlay_panel {
    z-index: 2000 !important;
}
.vc-alpha {
    display: none;
}

.dict-stat-table .badge {
    border-radius:0;
}
.dict-stat-table .badge-success, .dict-stat-table .badge-danger {
    width: 40px;
}
</style>
